import React from "react";
import "../../../styles/desktop/bombas.css";

export default function Bombas({ bombas = [] }) {
  if (!bombas.length) return (
      <p className="msgVaziaBombas">Sem alarme de Bombas</p>
  );

  return (
    <div className="GrupoAlarmes">
      {bombas.map((b) => (
        <div key={b.id} className="alarme">
          <p className="titleAlarme">{b.desc}</p>

          <div className={b.status ? "alertCircle" : "circleAlarm"}>
            <p>{b.status ? "Defeito" : "Ligada"}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
